/**
 * Video list component JS.
 */

import { h, app } from 'hyperapp'

( function( $ ) {

	if ( ! document.getElementById('video-list__app') ) {
		return
	}

	/**
	 * Functions
	 */

	const getVimeoIdByUrl = ( vimeoUrl ) => {
		let regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
		let parseUrl = regExp.exec( vimeoUrl )
		return parseUrl[5]
	}

	const setVideoData = ( videos ) => {
		for ( let i = videos.length - 1; i >= 0; i-- ) {
			let videoUrl = videos[i]['vimeo_url']
			let videoId = getVimeoIdByUrl( videoUrl )

			$.ajax({
				method: 'GET',
				url: 'https://vimeo.com/api/v2/video/' + parseInt( videoId ) + '.json',
				success: function( response ) {
					videos[i]['duration'] = response[0].duration
					videos[i]['img'] = response[0].thumbnail_medium
					App.updateVideos({ videos: videos })
				}
			})
		}
	}

	const padNumber = ( number, pad ) => {
		let N = Math.pow( 10, pad );
		return number < N ? ( '' + ( N + number ) ).slice(1) : '' + number
	}

	const secondsToTimeCode = ( seconds ) => {
		let minutes = Math.floor( seconds / 60 )
		let remainingSeconds = seconds - ( minutes * 60 )
		remainingSeconds = padNumber( remainingSeconds, 2 )

		return minutes + ':' + remainingSeconds
	}

	const updateCurrentVideo = ( e, video ) => {
		$( '.video-list__list-item' ).removeClass('active')
		e.currentTarget.classList.add('active')

		App.updateCurrentVideo({ currentVideo: video })
	}

	const setupPlyr = ( videoUrl ) => {

		let plyrArgs = {
			controls: [
				'play-large',
				'play',
				'progress',
				'current-time',
				'volume',
				'captions',
				'pip',
				'airplay',
				'fullscreen'
			]

		}

		if ( null !== document.getElementById('video-list__plyr-player') ) {

			// If first time initiating.
			let player = new Plyr( '#video-list__plyr-player', plyrArgs )

		} else {

			// Plyr edits the container now so you need to reset it.
			document.getElementById('video-list__player').innerHTML = '<div data-plyr-provider="vimeo" data-plyr-embed-id="' + videoUrl + '"></div>'
			let player = new Plyr( '#video-list__player > div', plyrArgs )

		}

	}

	const checkBrowserCompatibility = () => {
		let isntCompatible = (
			navigator.appVersion.indexOf('MSIE ') < -1 // IE <= 10
		)

		return ( ! isntCompatible )
	}

	/**
	 * App Components
	 */

	const state = {
		visible: 0,
		currentVideo: [],
		videos: [],
		isCompatible: checkBrowserCompatibility(),
	}

	const actions = {

		updateState: value => state => ({
			visible: value.visible,
			currentVideo: value.videos[0],
			videos: setVideoData( value.videos )
		}),

		updateVideos: value => state => ({
			videos: value.videos
		}),

		updateCurrentVideo: value => state => ({
			currentVideo: value.currentVideo
		})

	}

	const VideoPlayer = ({ currentVideo, isCompatible }) => {
		let currentVideoUrl = currentVideo['vimeo_url']

		if ( isCompatible ) {
			return (
				<div id="video-list__player" className="video-list__player">
					<div id="video-list__plyr-player" onupdate={ element => { setupPlyr( currentVideoUrl ) } } data-plyr-provider="vimeo" data-plyr-embed-id={currentVideoUrl}></div>
				</div>
			)
		} else {
			return (
				<div id="video-list__player" className="video-list__player">
					<div class="video-list__bad-browser">Our video player isn't supported by Internet Explorer. Please download a modern browser such as <a href="https://www.google.com/intl/en/chrome/" target="_blank">Chrome</a> or <a href="https://www.mozilla.org/en-US/firefox/" target="_blank">Firefox</a> to view our videos.</div>
				</div>
			)
		}
	}

	const VideoListItem = ({ title, subtitle, video, duration, img, i }) => {

		let altTag      = title + ' image'
		let timeCode    = secondsToTimeCode( duration )
		let activeClass = ( 0 === i ) ? ' active' : ''
		let classList   = 'reset video-list__list-item' + activeClass

		return (
			<button className={classList} onclick={ e => { updateCurrentVideo( e, video ) } }>
				<div className="image">
					<img src={img} alt={altTag} />
					<p className="time-code">{timeCode}</p>
				</div>
				<div className="text">
					<p className="h4__title">{title}</p>
					<p className="video-list__subtitle">{subtitle}</p>
				</div>
			</button>
		)
	}

	const VideoList = ({ videos }) => {

		if ( 'undefined' === typeof videos ) {
			return
		}

		return (
			<div className="video-list__list-container">

				<div className="video-list__list-header">
					<span>{videos.length}</span> Videos
				</div>

				<div className="video-list__item-container">
					<div className="video-list__list">
						{videos.map(({ title, subtitle, vimeo_url, duration, img }, i) => {
							return (
								<VideoListItem video={videos[i]} title={title} subtitle={subtitle} duration={duration} img={img} i={i} />
							)
						})}
					</div>
				</div>

			</div>
		)
	}

	const view = (state, actions) => {

		let visibleStyles = ! state.visible ? { display: 'none' } : {}

		return (
			<div className="video-list__container" style={visibleStyles}>
				<VideoPlayer currentVideo={state.currentVideo} isCompatible={state.isCompatible} />
				<VideoList videos={state.videos} />
			</div>
		)
	}

	const App = app( state, actions, view, document.getElementById('video-list__app') )

	$( document ).ready(() => {

		const videos = JSON.parse( document.getElementById('video-list__json').textContent )
		if ( videos.length > 0 ) {
			App.updateState({
				visible: 1,
				currentVideoUrl: videos[0]['vimeo_url'],
				videos: videos
			})
		}

	});



} ( jQuery ) );



// WEBPACK FOOTER //
// ./assets/js/components/layout/video-list.js